var exports = {
  "kL": "x234b8571--fb7a5c--container",
  "u": "x234b8571--fb7a5c--crumb",
  "UE": "x234b8571--fb7a5c--arrow",
};

module.exports = exports;
